import React, { useEffect, useRef, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import loadable from '@loadable/component';
import { Routes, Route, Navigate, useNavigate, useLocation } from "react-router-dom";
import { Layout } from 'antd';

import styles from './index.module.css';

import { onLoad } from './actions';
import TopPanel from '../components/TopPanel';

import { COGNITO } from "../server/cognito/config";
import Amplify from "aws-amplify";

Amplify.configure({
    aws_cognito_region: COGNITO.REGION,
    aws_user_pools_id: COGNITO.USER_POOL_ID,
    aws_user_pools_web_client_id: COGNITO.APP_CLIENT_ID,
});

const { Header, Content } = Layout;

const SideMenu = loadable(() => import('../components/SideMenu'));
const Home = loadable(() => import('../page/Home'));
const Login = loadable(() => import('../page/Login'));
const ForgotPassword = loadable(() => import('../page/Login/components/ForgotPasswordForm'));
const Search = loadable(() => import('../page/Search'));
const SearchOverseas = loadable(() => import('../page/SearchOverseas'));
const UserManagement = loadable(() => import('../page/UserManagement'));
const PartnerUserManagement = loadable(() => import('../page/PartnerUsers'));
const ProductManagement = loadable(() => import('page/ProductManagement/ProductHome'));
const ProductSelectHubPage = loadable(() => import('page/ProductManagement/ProductSelectHubPage'));
const ProductToggleWUServicePage = loadable(() => import('page/ProductManagement/ProductToggleWUServicePage'));
const ProductBankStatusChangePage = loadable(() => import('page/ProductManagement/BankStatusChangePage'));
const HubManagement = loadable(()  => import('page/HubManagement'));
const ServiceConfig = loadable(() => import('page/RefundBatchConfig/index'));
const AuditManagement = loadable(() => import('page/Audit/index'));
const RequestMessages = loadable(() => import('page/RequestMessages/index'));


function App(props) {
    const navigate = useNavigate();
    const prevAuthRef = useRef();
    const location = useLocation();
    const [forgotPasswordMode, setForgotPasswordMode] = useState(false);
    const [userProfile, setUserProfile] = useState(null);

    const forgotPasswordModeEnable = (value) => {
        setForgotPasswordMode(value);
    }

    useEffect(() => {
        if (!props.init) {
            props.onLoad();
        }
        if (forgotPasswordMode) {
            navigate('/forgot-password');
        } else if (!props.authenticated) {
            navigate('/login');
        } else if (prevAuthRef.current === false && props.authenticated) {
            navigate('/');
        }

        prevAuthRef.current = props.authenticated;
    }, [props, navigate, forgotPasswordMode]);

    return (
        <div className={styles['wrapper']}>
            <Layout className={styles['layout']}>
                {
                    props.authenticated ?
                        <Header className={styles['header']}>
                            {/* <TopPanel /> */}
                            <SideMenu
                                location={location}
                            />
                        </Header>
                        : ""
                }

                <Layout>
                    {
                        // props.authenticated ?
                            // <SideMenu
                            //     location={location}
                            // />
                            // : ""
                    }
                    <Layout>
                        <Content
                            style={{ marginLeft: '2%',
                            display: 'flex',
                            flexDirection: 'column',
                            flex: 1,
                            minHeight: 0,
                        }}>
                            {!props.authenticated ?
                                <Routes>
                                    <Route path="/" element={<Home />} />
                                    <Route path="login" element={<Login forgotPasswordModeEnable={forgotPasswordModeEnable} />} />
                                    <Route path="forgot-password" element={<ForgotPassword forgotPasswordModeEnable={forgotPasswordModeEnable} />} />
                                    <Route path="*" element={<Navigate to="/" />} />
                                </Routes>
                                : ""
                            }
                            {props.sideMenuInit ?
                                <Routes>
                                    <Route path="/" element={<Home />} />
                                    <Route path="search/remittance" element={<Search />} />
                                    <Route path="search/overseas" element={<SearchOverseas />} />
                                    <Route path="admin/user" element={<UserManagement />} />
                                    <Route path="admin/partner-user" element={<PartnerUserManagement />} />
                                    <Route path="setting/product" element={<ProductManagement />} />
                                    <Route path="setting/product/select-hub" element={<ProductSelectHubPage />} />
                                    <Route path="setting/product/toggle-wu-service" element={<ProductToggleWUServicePage />} />
                                    <Route path="setting/product/update-bank-wallet" element={<ProductBankStatusChangePage />} />
                                    <Route path="hubmanagement/hubservicedata" element={<HubManagement />} />
                                    <Route path="/config/batch_refund" element={<ServiceConfig />} />
                                    <Route path="audit/" element={<AuditManagement />} />
                                    <Route path="requestMessages/" element={<RequestMessages />} />
                                    <Route path="*" element={<Navigate to="/" />} />
                                </Routes>
                                : ""
                            }
                        </Content>
                    </Layout>
                </Layout>
            </Layout>
        </div>
    );
}

const mapStateToProps = state => ({
    authenticated: state.app.authenticated,
    sideMenuInit: state.sideMenu.init,
    init: state.app.init
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            onLoad
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(App);
